import React from 'react';

function ConcessionsHotspot(props) {
  const { onClick, style, className } = props;
  return (
    <div onClick={onClick} style={{cursor:'pointer', ...style}} className={className}>
      <img src={require('./ConcessionsHotspot.svg').default} alt="" style={{width:'100%',height:'auto'}} />
    </div>
  );
}

export default ConcessionsHotspot;
